import "./marketList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import MarketTable from "../localmarkettable/MarketTable";

const MarketList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <MarketTable />
      </div>
    </div>
  );
};

export default MarketList;
